import { BackButton } from "../../../../../design-system/components/BackButton/BackButton.jsx";
import styles from "./SparkStepHeader.css.ts";

/**
 * Renders the header component for a Spark step, including chapter and module titles,
 * as well as optional module navigation and a close button.
 *
 * @param {Object} props - The properties to configure the component.
 * @param {string} props.chapterTitle - The title for the chapter.
 * @param {string} props.moduleTitle - The title for the module.
 * @param {JSX.Element|null} props.StepNavigation - Optional element for module navigation. Defaults to null.
 *
 * @return {JSX.Element} The rendered header component.
 */
export function SparkStepHeader({
  chapterTitle,
  moduleTitle,
  StepNavigation = null,
}) {
  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <BackButton backPath={".."} theme={"light"} />
        <div className={styles.title}>
          {chapterTitle && (
            <h1 className={styles.chapterTitle}>{chapterTitle}</h1>
          )}
          {moduleTitle && <h2 className={styles.moduleTitle}>{moduleTitle}</h2>}
        </div>
        <div className={styles.navigation}>{StepNavigation}</div>
      </div>
    </div>
  );
}
